import React from "react";
import { Icon, Modal, PlainButton } from "@culturehq/components";

import { Trans } from "app/utils";
import ChqModal from "components/common/ChqModal";

const StoryTrendSummary = ({ prompt, summary, title }) => (
  <ChqModal
    ariaLabelledBy="trend-summary"
    ariaDescribedby="trend-summary"
    className="StoryTrend-Summary"
    trigger={onTrigger => (
      <PlainButton className="StoryTrend-Summary__Btn" onClick={onTrigger}>
        <Trans>Read more</Trans>
        <Icon icon="android-open" />
      </PlainButton>
    )}
    entrance="zoomIn"
    width="narrow"
  >
    <Modal.Heading>
      <h2 id="trend-summary"><Trans>{title}</Trans></h2>
    </Modal.Heading>
    <Modal.Body>
      <h3 className="Story-Prompt">
        <Icon className="quote-icon" icon="quote" />
        {prompt}
      </h3>
      <p aria-labelledby="instructions-context-modal" className="Story-Summary">
        {summary}
      </p>
      <span id="instructions-context-modal" className="hidden">Instructions to this prompt</span>
    </Modal.Body>
  </ChqModal>
);

export default StoryTrendSummary;
